import { Employee } from "./useEmployee";

export enum Gender {
  FEMALE = "female",
  MALE = "male",
}

interface DeliveryAddress {
  streetName: string | null;
  streetNumber: string | null;
  details: string | null;
  street: string;
  postalCode: string | null;
  province: string | null;
  locality: string | null;
  district: string | null;
}

interface TermsAndConditions {
  accept: boolean;
  version: string;
  ip: string;
  useragent: string;
  connectionType: string;
  dateTimestamp: number;
  deviceBrand: string;
  deviceId: string;
  deviceName: string;
  deviceMacAddress: string;
  idNovationContract: string;
  companyId: string;
  hash: string;
}

interface HomeAddress {
  streetName?: string;
  streetNumber?: string;
  details?: string;
  street: string;
  postalCode: string;
  province: string;
  locality: string;
  district?: string;
}

interface RegionalInfo {
  countryISO2Code: string;
}

interface EmployeeBackend {
  id: string;
  internalId: string;
  costCenter: string;
  costCenterId: null | number;
  payrollCompany: string;
  email: string;
  grossSalary: string;
  bankAccount: null;
  name: string;
  surname: string;
  legalId: string;
  sex: Gender;
  maritalStatus: null;
  birthDate: string;
  incapacityLevel: string;
  companyId: string;
  modelId: string;
  companyName: string;
  activationId: string;
  mobileCountryCode: string;
  mobilePhone: string;
  deliveryAddress: DeliveryAddress;
  state: string;
  stateHistory: string[];
  termsAndConditions: TermsAndConditions;
  error: null;
  warning: null;
  removalTimestamp: null;
  creationTimestamp: number;
  requestCardTimestamp: null;
  activeSinceTimestamp: number;
  activeInCurrentCompanySinceTimestamp: number;
  taxRegime: string;
  familyMembers: any[];
  homeAddress: HomeAddress;
  language: string;
  hiringDate: string;
  profession: null;
  removedFromAuth0Timestamp: null;
  daysPerMonth: number;
  uploadingId: string;
  inMigration: boolean;
  regionalInfo: RegionalInfo;
  source: string;
  metadata: null;
}

const restoreEmployee = (employee: EmployeeBackend): Employee => {
  return {
    id: employee.id,
    name: employee.name,
    surname: employee.surname,
    companyId: employee.companyId,
    state: employee.state,
    homeAddress: employee.homeAddress,
    email: employee.email,
    mobilePhone: employee.mobilePhone,
    birthDate: employee.birthDate,
    sex: employee.sex,
  };
};

export { restoreEmployee };
